module.exports = __webpack_public_path__ + "media/images/responsive/fairs/point_border-e6d849aba35afc0b99ff5b4d2e5b8c92.svg";